import { render, staticRenderFns } from "./EventDetailVideoDialog.vue?vue&type=template&id=cc723600&scoped=true"
import script from "./EventDetailVideoDialog.vue?vue&type=script&lang=js"
export * from "./EventDetailVideoDialog.vue?vue&type=script&lang=js"
import style0 from "./EventDetailVideoDialog.vue?vue&type=style&index=0&id=cc723600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc723600",
  null
  
)

export default component.exports